/**
 * Generates a URL-friendly slug from a given string
 * @param name - The string to convert to a slug
 * @returns A lowercase, hyphenated slug with special characters removed
 */
export function generateSlug(name: string): string {
  return name
    .replace(/&shy;/g, "")
    .replace(/ä/g, "ae") // Replace German umlauts first
    .replace(/ö/g, "oe")
    .replace(/ü/g, "ue")
    .replace(/Ä/g, "Ae")
    .replace(/Ö/g, "Oe")
    .replace(/Ü/g, "Ue")
    .replace(/ß/g, "ss")
    .replace(/\(/g, " ") // Replace opening parenthesis with space
    .replace(/\)/g, "") // Remove closing parenthesis
    .toLowerCase()
    .replace(/[^a-z0-9\s-]/g, "") // Remove special characters
    .replace(/\s+/g, "-") // Replace spaces with hyphens
    .replace(/-+/g, "-") // Replace multiple hyphens with single
    .trim();
}
